import { CollectionFieldsFragment } from 'generated/graphql';

export enum CollectionType {
  Lp = 0,
  Ep = 1,
}

export type Collection = CollectionFieldsFragment;
